import { tSharedAppState, tSharedStore } from 'common/modules/ReactShared';
import { createSelector, Selector } from '@reduxjs/toolkit';
import parentSelectors from '../selectors';

const selectStore: Selector<tSharedAppState, tSharedStore['member']['myLessons']> =
  createSelector([parentSelectors.selectMemberStore], (parent) => parent.myLessons);

const selectors = {
  selectStore
};

export { selectors };
